import { useState } from 'react'
import { Button, Empty, Tabs, Typography } from 'antd'
import { CloseOutlined, CommentOutlined } from '@ant-design/icons'
import ReturnHistory from './ReturnHistory'

export default function AppraisalConversationSidebar({ appraisal, feedback, composer, actions, open, onOpen, onClose }) {
    const [activeTab, setActiveTab] = useState('comments')
    const count = appraisal.return_history?.length || (appraisal.return_comments ? 1 : 0)

    return (
        <div className={`tti-review-panel-slot${open ? ' tti-review-panel-slot--open' : ''}`}>
            {!open && (
                <Button className='tti-review-launcher tti-btn-secondary' icon={<CommentOutlined />} onClick={onOpen}>
                    Review & Feedback{count ? ` (${count})` : ''}
                </Button>
            )}
            <aside className='tti-review-panel' aria-label='Review & Feedback' hidden={!open}>
                <header className='tti-review-panel__header'>
                    <Typography.Text strong>Review & Feedback</Typography.Text>
                    <Button type='text' icon={<CloseOutlined />} aria-label='Close review and feedback' onClick={onClose} />
                </header>
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    className='tti-review-tabs'
                    items={[
                        {
                            key: 'comments',
                            label: 'Comments',
                            children: (
                                <>
                                    <div className='tti-review-log'>
                                        <ReturnHistory appraisal={appraisal} compact newestFirst />
                                        {!count && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No comments yet' />}
                                    </div>
                                    {(composer || actions) && (
                                        <div className='tti-review-reply'>
                                            {composer}
                                            {actions && <div className='tti-review-send'>{actions}</div>}
                                        </div>
                                    )}
                                </>
                            )
                        },
                        { key: 'feedback', label: 'Feedback', children: feedback || <Empty description='No feedback provided yet' /> }
                    ]}
                />
            </aside>
        </div>
    )
}